var tasks = {
  base: ['/', 'login', 'logout', 'changepass', 'home'],
  dispatching: ['calendar', 'timeline', 'client', 'driver', 'destination', 'booking', 'distance', 'mail', 'help', 'myDrivers', 'planningBooqit'],
  accounting: [
    'archiveDrivers',
    'walletclient', 'invoice', 'archive',
    'inserts', 'expenses'
  ],
  invoicing: [
    'invoicing',
    'walletdriver', 'invoicesDrivers', 'archiveDrivers',
    'walletclient', 'invoice', 'archive',
    'inserts', 'expenses', 'tickets', 'calculate'
  ],
  insurance: [
    'walletinsurrance', 'invoiceInsurance', 'archiveInsurances'
  ]
};

var roles = {
  dispatch: [...tasks.base, ...tasks.dispatching],
  account: [...tasks.base, ...tasks.accounting],
  invoice: [...tasks.base, ...tasks.invoicing, 'mail'],
  admin: [...tasks.base, ...tasks.dispatching, 'transportsBooqit'],
  // lead: [...tasks.base, ...tasks.dispatching, 'timesheet', 'invoicesBooqit', 'transportsBooqit'],
  lead: [...tasks.base, ...tasks.dispatching, 'walletdriver', 'invoicesDrivers', 'archiveDrivers', 'transportsBooqit'],
  super: ['*']
};

var can = (role, path) => {
  if (!roles[role]) return false;
  if (roles[role].includes('*')) return true;
  return roles[role].includes(path);
};

export default {
  can: can
}
